<template>
  <div>
    <section>
      <v-container container--fluid grid-list-md>
        <v-row class="mt-2 ml-4">
          <v-col cols="12" md="8">
            <h1 class="text-little">Manage Manifest Formats</h1>
          </v-col>
          <v-col cols="12" md="4" :class="$vuetify.breakpoint.smAndDown ? 'text-center': 'text-right'">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newManifest" v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new manifest format</span>
            </v-tooltip>
          </v-col>

          <!--            <v-col cols="2" offset-md-3>-->
          <!--              <v-switch label="Show Inactive"-->
          <!--                        v-model="inactiveSwitch"-->
          <!--                        style="justify-content: center; display: flex;"></v-switch>-->
          <!--            </v-col>-->

        </v-row>
      </v-container>

      <v-divider color="#42a5f5"></v-divider>

      <template>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="blue"
          grow
          slider-color="cyan accent-4"
        >
          <v-tab>
            <v-icon class="mr-2">fas fa-user</v-icon>
            Manifests Table
          </v-tab>
          <v-tab>
            <v-icon class="mr-2">fas fa-scroll</v-icon>
            Edit Manifest
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            :key="0"
          >
            <v-card flat>
              <ManifestsTable
                :manifests="manifests"
                :select-client="selectClient"
              ></ManifestsTable>
            </v-card>
          </v-tab-item>

          <v-tab-item
            :key="1"
          >
            <v-card flat>
              <EditManifest
                v-if="clientManifest"
                :manifest="clientManifest"
                :isNew="isNew"
                v-on:cancel="close()"
                v-on:save="pushInManifests"
                v-on:modify="replaceManifest"
                @putSuccess="updateTable"
                :client="client">
              </EditManifest>
              <v-alert v-else color="#c4e3f1">
                <v-row align="center" justify="center">
                  <v-col cols="12" class="text-center">
                    <v-icon large>warning</v-icon>
                   <p>Please ensure you select a client to download its manifest formats.</p>
                  </v-col>

                </v-row>
              </v-alert>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

      </template>
    </section>

  </div>
</template>

<script>
    import ManifestsTable from "../../util/ManageManifests/ManifestsTable";
    import EditManifest from "../../util/ManageManifests/EditManifest";
    import axios from 'axios'

    export default {
        name: "ManageManifests",
        components: {EditManifest, ManifestsTable},
        data() {
            return {
                tab: 0,
                newManifestDialog: false,
                inactiveSwitch: true,
                clientManifest: null,
                client: null,
                editedIndex: null,
                isNew:true,
                reload: false,
            }
        },
        methods: {
            pushInManifests(manifest) {
                this.manifests.unshift(manifest);
                this.close();
            },
            replaceManifest(manifest, index) {
                Object.assign(this.manifests[index], manifest);
                this.close();
            },
            close() {
                this.tab = 0;
                this.clientManifest = null;
                this.client = null;
                this.isNew = true;
            },
            updateTable(){
              this.reload = !this.reload;
            },
            newManifest() {
                this.clientManifest = {
                    id: -1,
                    client_id: 0,
                    region_id: 0,
                    format: '',
                    constants: null,
                    skip_rows: 1,
                    custom_skip: null,
                    on_init: null,
                    pre_process: null,
                    post_process: null,
                    before_write: null,
                    consolidate_tags: true,
                    custom_tag: null,
                    select_timewindow: null,
                    generate_serials: false,
                    multi_day: false,
                    multi_window: false,
                    multi_region: false,
                    unique_tags: false,
                    enable_linehaul:false,
                    enable_production:false
                };
                this.tab = 1;
                this.isNew = false
                this.$store.commit('displaySnackbar', 'Manifest Format Creation.');
            },

            selectClient(clientManifest, client) {
                axios.get(process.env.API_URL + '/manifestformats/' + clientManifest.id)
                    .then((response) => {
                        this.client = client;
                        this.clientManifest = Object.assign({}, response.data);
                        this.tab = 1;
                        this.$store.commit('displaySnackbar', 'Information on client: ' + client.name);
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            }
        },
        asyncComputed: {
            async manifests() {
              if (this.reload || !this.reload) {
                return await axios.get(process.env.API_URL + '/manifestformats')
                  .then((response) => {
                    return response.data;
                  })
                  .catch((response) => {
                    return [];
                  })
              }
            }
        }
    }
</script>

<style scoped>
  >>> .v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/ManageManifests.vue